import LocalizedMessage from '../common/LocalizedMessage';
import React from "react";
import PropTypes from "prop-types";
import { displayDate } from "../common/datePresentation";
import { useTranslation } from 'react-i18next';

const ClassLessonHistoryModal = ({ open, loading, error, items, nextCursor, onClose, onLoadMore }) => {
  const { t: tr , i18n } = useTranslation();
  if (!open) return null;
  return (
    <div className="attendance-page__modal-placeholder" role="dialog" aria-modal="true" aria-labelledby="lesson-history-title">
      <div className="attendance-page__modal-card attendance-page__history-modal">
        <div className="attendance-page__lesson-summary-heading">
          <h3 id="lesson-history-title" className="attendance-page__modal-title">{tr("manage:previousTopicsForThisGroup_86")}</h3>
          <button type="button" className="btn manage-button manage-teal-button" onClick={onClose}>{tr("common:close")}</button>
        </div>
        {error && <div className="alert alert-danger" role="alert"><LocalizedMessage isError value={error} /></div>}
        {!loading && !error && items.length === 0 && <p>{tr("manage:thereAreNoPreviousLessonsToDisplay_87")}</p>}
        <div className="attendance-page__history-list">
          {items.map(item => (
            <article key={item.lessonId} className="attendance-page__history-item">
              <div className="attendance-page__history-meta">
                <strong>{displayDate(item.date, i18n.language)}{item.startTime ? `, ${item.startTime}` : ""}</strong>
                {item.teacherName && <span>{item.teacherName}</span>}
              </div>
              {item.status === "cancelled" && <p>{tr("manage:lessonCancelled_54")}</p>}
              {item.status === "noSummary" && <p>{tr("manage:noSummaryHasBeenAdded_88")}</p>}
              {item.status === "summarized" && <p>{item.lessonSummary}</p>}
            </article>
          ))}
        </div>
        {loading && <p role="status">{tr("manage:loadingPreviousTopics_89")}</p>}
        {nextCursor && !loading && (
          <button type="button" className="btn manage-button manage-teal-button" onClick={onLoadMore}>{tr("manage:showOlder_90")}</button>
        )}
      </div>
    </div>
  );
};

ClassLessonHistoryModal.propTypes = {
  open: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    lessonId: PropTypes.string.isRequired,
    date: PropTypes.string,
    startTime: PropTypes.string,
    teacherName: PropTypes.string,
    status: PropTypes.string.isRequired,
    lessonSummary: PropTypes.string,
  })).isRequired,
  nextCursor: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onLoadMore: PropTypes.func.isRequired,
};

ClassLessonHistoryModal.defaultProps = { error: "", nextCursor: null };

export default ClassLessonHistoryModal;
